import { Typography } from '@material-ui/core';
import type { LaunchPadData } from '@mogul/api-client';
import React, { useEffect, useState } from 'react';

import discordIcn from '../../common/svg/launchpad/icon-discord.svg';
import globeIcn from '../../common/svg/launchpad/icon-globe.svg';
import twitterIcn from '../../common/svg/launchpad/icon-twitter.svg';
import { Button as CoreButton } from '../core/button/Button';
import styles from './LaunchpadMinting.module.css';

export interface Props {
  launchPadData: LaunchPadData | undefined;
  preSales: number;
  history: any;
}

export const LaunchpadInfo: React.FC<Props> = props => {
  const [communityInfos, setCommunityInfos] = useState<any>({});

  const { history } = props;

  useEffect(() => {
    setCommunityInfos(props.launchPadData?.communityInfo);
  }, [props]);

  const viewCollection = () => {
    history.push(
      `/platform/collection/eth/${props.launchPadData?.collection?.slug}`,
    );
  };

  const goToMarketplace = () => {
    history.push(`/platform/marketplace`);
  };

  return (
    <div>
      <div
        className={'flex justify-center items-center h-44 w-full'}
        style={{
          backgroundImage: `url(${props.launchPadData?.collection?.bannerImageUrl})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '2% 50%',
        }}
      ></div>

      <div className="flex flex-col justify-center items-center">
        <div
          className={'lg:w-8/12 sm:w-9/12 w-5/6 rounded-tl-lg rounded-tr-lg'}
        >
          <div
            className={
              styles.headerTitle + ' my-6 font-bold text-4xl break-words'
            }
          >
            {props.launchPadData?.collection?.name}
          </div>
          <div
            className={
              styles.headerDescription +
              ' mr-7 font-semibold text-sm break-words'
            }
          >
            {communityInfos.subHeader ?? ''}
          </div>
          <div className="md:mt-8 mt-6 mb-6">
            <Typography
              style={{
                padding: '5px 30px',
                width: 'fit-content',
                fontSize: '14px',
                marginTop: '-10px',
                border: '2px solid #FCD559',
                textAlign: 'center',
                color: '#FCD559',
              }}
            >
              Featured Launch
            </Typography>
          </div>
          <div className="flex flex-wrap lg:justify-start justify-center mt-2">
            <div className="xl:w-6/12 w-full flex flex-col xl:items-start items-center">
              <img
                className={
                  styles.collectionPicCol + ' xl:w-10/12 w-full h-auto'
                }
                src={`${props.launchPadData?.collection?.logoImageUrl}`}
                alt="collectionImage"
              />
            </div>
            <div className="xl:w-5/12 xl:ml-12 xl:mt-0 mt-10 mb-14 w-full flex flex-col xl:items-start items-center">
              <div className="flex w-full xl:justify-start justify-center">
                {communityInfos.discord ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.discord ?? ''}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="h-6 w-6"
                      src={discordIcn}
                      alt="discordIcon"
                    />
                  </a>
                ) : null}
                {communityInfos.twitter ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.twitter ?? ''}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="h-6 w-6"
                      src={twitterIcn}
                      alt="twitterIcon"
                    />
                  </a>
                ) : null}
                {communityInfos.website ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.website ?? ''}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img className="h-6 w-6" src={globeIcn} alt="globeIcon" />
                  </a>
                ) : null}
              </div>
              <p className="text-sm mt-4 whitespace-pre-line">
                {props.launchPadData?.collection?.description}
              </p>

              <div className={styles.buttonContainer}>
                <CoreButton
                  onClick={viewCollection}
                  className="w-full mr-2"
                  label={'View Collection'}
                />
                <CoreButton
                  onClick={goToMarketplace}
                  className={styles.marketPlaceButton + ' w-full ml-2'}
                  label={'Marketplace'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
